import baustein from "baustein";
import { watchState } from "web/redux/state-watcher";

function extractFilterState(state) {
    return state.feedFiltersReducer.title;
}

export default baustein.register("feed-title", {
    init() {
        watchState(extractFilterState, (title) => {
            if (title) {
                this.el.innerText = title;
            }
        });
    },
});
